export { fetchChannels as fetchChannelAssets } from '../../phoenix';
